function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import { StyledFactQuoteComponent } from "./fact-quote-component.scss";
import { convertToArrayIfNeeded } from "utils/arrays";
class FactQuoteComponent extends PureComponent {
    renderParagraphs(paragraphs) {
        return paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: paragraph
                }
            }, index));
    }
    render() {
        const { image, body, personName, companyName } = this.props;
        let contentBody = convertToArrayIfNeeded(body);
        contentBody = this.renderParagraphs(contentBody);
        return /*#__PURE__*/ _jsxs(StyledFactQuoteComponent, {
            className: "fact-quote-component",
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, _object_spread_props(_object_spread({}, image), {
                    pictureClass: "quote-person-image"
                })),
                /*#__PURE__*/ _jsxs("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ _jsx("q", {
                            className: "quote",
                            children: contentBody
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "details",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "person-name",
                                    children: personName
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "seperator",
                                    children: "|"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "company-name",
                                    children: companyName
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { FactQuoteComponent as default };
